import { dasherize } from '@ember/string';
import Component from '@glimmer/component';

type TSpacing = 0 | 1 | 2 | 3 | 4;

type TAlignment = 'leading' | 'trailing' | 'center' | 'fill' | 'baseline';

type TDistribution =
  | 'equalSpacing'
  | 'leading'
  | 'trailing'
  | 'center'
  | 'fill'
  | 'fillEvenly'
  | 'justify';

function variationName(name: string, value: any) {
  return `bv-stack--${name}-${value}`;
}

export interface IBvStackArgs {
  /** Wrap stack elements to additional rows as needed on small screens (Defaults to true) */
  wrap?: boolean;
  /** Stack the elements vertically */
  vertical?: boolean;
  /** Adjust spacing between elements */
  spacing?: TSpacing;
  /** Adjust vertical alignment of elements */
  alignment?: TAlignment;
  /** Adjust horizontal alignment of elements */
  distribution?: TDistribution;
}

export default class BvStack extends Component<IBvStackArgs> {
  get spacingClass() {
    const { spacing } = this.args;
    return spacing ? variationName('spacing', spacing) : undefined;
  }

  get alignClass() {
    const { alignment } = this.args;
    return alignment ? variationName('alignment', alignment) : undefined;
  }

  get distributeClass() {
    const { distribution } = this.args;
    return distribution ? variationName('distribution', dasherize(distribution)) : undefined;
  }
}
